import AutoSuggestModel from "@Features/autosuggest/models/AutoSuggestModel";
import {fetchSuggestions} from "@Form/functions/fetchSuggestions";
import stripTags from "@Form/functions/stripTags";
import {useState} from "react";
import toggleArrayMember from "@Array/toggleArrayMember";

export default function useStationsAutoSuggest(stationsIds, idsHandler, handleSelection, namesHandler) {
    const [selection, setSelection] = useState('')
    const suggestionClickHandler = async (input) => {
        if (input) {
            toggleArrayMember(idsHandler, stationsIds, stripTags(input?.value), true)
            namesHandler({id: stripTags(input?.value), name: stripTags(input?.label)})
            setSelection('')
            handleSelection()
        }
    }

    return new AutoSuggestModel({
        suggestionLengthFetchLimit: 2,
        suggestionsHandler: fetchSuggestions,
        suggestionClickHandler,
        inputHandler: (input) => (stripTags(input)),
        clearHandler: () => setSelection(''),
        selection,
    })
}